import { CSSProperties } from 'react';

export const containerStyle = (isLoading: boolean): CSSProperties => ({
  paddingTop: '12px',
  paddingBottom: '100px',
  display: 'flex',
  overflow: isLoading ? 'hidden' : 'auto',
  overscrollBehavior: 'none',
  flexWrap: 'wrap',
  gap: '15px',
  width: 'calc(100% - 40px)',
  height: '100%',
  boxSizing: 'border-box'
});

export const likeContainerStyle: CSSProperties = {
  height: '220px',
  width: 'calc(50% - 8px)',
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '35px'
};
